// extracted by mini-css-extract-plugin
module.exports = {"editIcon":"_2EAEU"};